import { currentLocale } from '../i18n';

/** Fechas y tiempos relativos en el formato del idioma activo (es-ES / en-GB). */
const cache = new Map<string, Intl.DateTimeFormat>();
function dtf(locale: string, withTime: boolean) {
  const key = `${locale}|${withTime}`;
  let f = cache.get(key);
  if (!f) {
    f = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
    });
    cache.set(key, f);
  }
  return f;
}

export const fmtDate = (s: string | null | undefined) => (s ? dtf(currentLocale(), false).format(new Date(s)) : '—');
export const fmtDateTime = (s: string | null | undefined) => (s ? dtf(currentLocale(), true).format(new Date(s)) : '—');
export const fmtNumber = (n: number) => n.toLocaleString(currentLocale());

export function fmtRelative(s: string | null | undefined, now = Date.now()): string {
  if (!s) return '—';
  const diff = new Date(s).getTime() - now;
  const abs = Math.abs(diff);
  const rtf = new Intl.RelativeTimeFormat(currentLocale(), { numeric: 'auto' });
  const units: [Intl.RelativeTimeFormatUnit, number][] = [
    ['day', 86_400_000],
    ['hour', 3_600_000],
    ['minute', 60_000],
  ];
  for (const [unit, ms] of units) if (abs >= ms) return rtf.format(Math.round(diff / ms), unit);
  return rtf.format(0, 'second');
}

export const shortFp = (fp: string) => `${fp.slice(0, 8)}…${fp.slice(-6)}`;

/** Días hasta una fecha (negativo si ya pasó). */
export function daysUntil(s: string | null | undefined, now = Date.now()): number | null {
  if (!s) return null;
  return Math.ceil((new Date(s).getTime() - now) / 86_400_000);
}
